export const termsContent = {
  title: "Terms of Service",
  lastUpdated: "June 2026",
  sections: [
    {
      heading: "1. Lawful Platform Utilization",
      text: "You agree to utilize BizNearYou strictly in compliance with all local, state, federal, and international regulations. Any form of harassment, automated abuse, bulk spamming, deceitful impersonation, or discriminatory targeting of local employers or personnel is strictly prohibited."
    },
    {
      heading: "2. Accuracy of Data & Disclaimers",
      text: "Data available through the BizNearYou platform is compiled from publicly accessible records, third-party mapping providers, and manual directory crawls. Consequently, data may sometimes be outdated, incomplete, or contain inaccuracies."
    },
    {
      heading: "3. Absolute No-Guarantee Covenant",
      text: "BizNearYou is an informational utility only. We do not guarantee employment, Business quality, outreach response rates, business outcomes, or hiring validity. Users are individually responsible for verifying job details, company reputation, and safety before initiating contact or accepting offers."
    }
  ]
};
